import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=3c23c9f6&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=3c23c9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23c9f6",
  null
  
)

export default component.exports